module.exports = __webpack_public_path__ + "img/user-grey.56fd9213.svg";